module.exports = __webpack_public_path__ + "media/images/patent/x_2-66f1aaf3ecbfdb140f5104fd72b77906.png";